import { MouseEventHandler, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { setDocumentTitle } from 'utils/meta/setDocumentTitle';
import { scrollToHash } from 'utils/scrollIntoView';
import { getParam, hasParam } from 'utils/url';

import { CmsContentPageWrapper } from './CmsContentPageWrapper';

type Props = {
  content: CmsApiPage;
};

export function CmsContentPage({ content }: Props) {
  const location = useLocation();

  const onClickContent: MouseEventHandler<HTMLElement> = useCallback((e) => {
    const el = e.target as HTMLElement;
    const href = el.getAttribute('href');

    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
    if (el.nodeName === 'A' && /^#/.test(href)) {
      e.preventDefault();
      // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      scrollToHash(href);
    }
  }, []);

  useEffect(() => {
    setDocumentTitle(content.headTitle || content.title);
  }, [content.headTitle, content.title]);

  useEffect(() => {
    if (hasParam(location.search, 'block')) {
      const el = document.getElementById(
        `cms-block-${getParam(location, 'block')}`,
      );

      if (el) {
        window.scrollBy(0, el.getBoundingClientRect().top - 200);
      }
    }
  }, [location]);

  useEffect(() => {
    if (window.location.hash) {
      window.setTimeout(() => {
        scrollToHash(window.location.hash.split('?')[0], {
          padding: 32,
          noTransition: true,
        });
      }, 1);
    }
  }, []);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={onClickContent}>
      <CmsContentPageWrapper content={content} />
    </div>
  );
}
